<template>
  <div class="v-related-sites-list">
    <div class="v-related-sites-list__content">
      <sheet>
        <loading v-if="isLoading"/>
        <div class="execute" v-else>
          <accordion :data="allSites" />
        </div>
      </sheet>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, watch, h,
} from 'vue';
import { v4 as uuid } from 'uuid';
import Accordion from '@/components/Global/Accordion.vue';
import { relatedSites } from '@/config/accordion';
import { getArticleListAPI } from '@/api/list';
import { getIndexCategoriesAPI } from '@/api/categories';
import OpenList from '@/components/Global/OpenList.vue';
import useRequest from '@/hooks/useRequest';

export default defineComponent({
  name: 'related-sites',
  components: {
    Accordion,
  },
  setup() {
    const allSites = ref([]);
    const formContent = ref([]);
    const allKeys = ref([]);

    const { response, request, isLoading } = useRequest(getArticleListAPI);
    // request({ type: 'websites', status: true });

    const { response: getIndexCategoriesResponse, request: getIndexCategoriesRequest } = useRequest(getIndexCategoriesAPI);
    getIndexCategoriesRequest({ type: 'websites', status: true });

    // const downloadList = {
    //   government: [
    //     { label: '衛生福利部', link: 'http://www.mohw.gov.tw/CHT/Ministry/Index.aspx' },
    //     { label: '衛生福利部國民健康署', link: 'https://www.hpa.gov.tw/home/index.aspx' },
    //     { label: '衛生福利部中央健康保險署', link: 'https://www.nhi.gov.tw/Default.aspx' },
    //     { label: '衛生福利部疾病管制署', link: 'https://www.cdc.gov.tw/?aspxerrorpath=/rwd' },
    //     { label: '衛生福利部社會及家庭署', link: 'https://www.sfaa.gov.tw/SFAA/default.aspx' },
    //     { label: '衛生福利部社會救助及社工司', link: 'https://dep.mohw.gov.tw/DOSAASW/mp-103.html' },
    //     { label: '國民健康署孕產婦關懷網站', link: 'http://mammy.hpa.gov.tw/' },
    //     { label: '國民健康署戒菸專線服務中心', link: 'http://www.tsh.org.tw/' },
    //   ],
    //   medical: [
    //     { label: '台灣婦產科醫學會', link: 'http://www.taog.org.tw/htm/index.asp' },
    //     { label: '台灣周產期醫學會', link: 'https://www.tsop.org.tw/links.php' },
    //     { label: '台灣生殖醫學會', link: 'http://www.tsrm.org.tw/' },
    //     { label: '台灣兒科醫學會', link: 'https://www.pediatr.org.tw/' },
    //     { label: '台灣新生兒科醫學會', link: 'http://www.tsn-neonatology.com/' },
    //   ],
    //   benefitAndHealth: [
    //     { label: '智邦公益館', link: 'http://www.17885.com.tw/' },
    //     { label: '台灣公益資訊中心', link: 'http://www.npo.org.tw/index.asp' },
    //     { label: '台灣婦女團體全國聯合會', link: 'http://www.natwa.org.tw/' },
    //     { label: 'uho', link: '優活健康網 http://www.uho.com.tw/' },
    //     { label: '嬰兒與母親', link: 'http://www.npo.org.tw/index.asp' },
    //     { label: '媽媽寶寶', link: 'https://www.mombaby.com.tw/' },
    //   ],
    //   foreign: [
    //     { label: '歐洲新生兒照護基金會(EFCNI)', link: 'https://www.efcni.org/?id=991' },
    //     { label: '大阪母子保健總合醫療中心', link: 'https://www.wch.opho.jp/' },
    //     { label: '美國 March of Dimes基金會', link: 'http://www.marchofdimes.com/' },
    //     { label: '關於餵食母乳的專業國際機構組織', link: 'http://www.lalecheleague.org/' },
    //     { label: 'Sidelines National Support Network.', link: 'http://www.sidelines.org' },
    //     { label: 'The Twin To Twin Transfusion Syndrome Foundation.', link: 'http://www.tttsfoundation.org' },
    //     { label: 'Breastfeeding(母乳哺餵)', link: 'http://www.ilca.org' },
    //   ],
    // };

    const getViewArticles = async (res) => {
      try {
        const {
          result: {
            data: articleList,
          }, status,
        } = res.value;

        console.log(status, articleList);

        if (status) {
          // const baseUrl = process.env.VUE_APP_BASE_URL;

          articleList.forEach((item) => {
            if (allKeys.value.includes(item.category.name)) {
              console.log('item', item.data.web_url);
              formContent.value[item.category.name].push({
                label: item.title,
                link: item.data.web_url,
              });
            }
          });

          const KeysOfkeyWithContent = [];
          allKeys.value.forEach((key) => {
            if (formContent.value[key].length) {
              KeysOfkeyWithContent.push(key);
            }
          });

          allSites.value = KeysOfkeyWithContent.map((key) => ({
            key: uuid(),
            title: key,
            renderContent: h(OpenList, {
              list: formContent.value[key],
            }),
          }));
        }
      } catch (e) {
        console.log('e', e);
        allSites.value = [];
      }
    };

    watch(response, () => {
      getViewArticles(response);
    });

    watch(getIndexCategoriesResponse, () => {
      /* ฅʕ •ﻌ• ʔฅ  篩選出 websites 分類 ♬*ﾟ */
      const res = getIndexCategoriesResponse.value;
      if (res.status) {
        allKeys.value = res.result.data.filter((i) => i.type === 'websites').map((i) => i.name);
        formContent.value = allKeys.value.reduce((obj, key) => {
          obj[key] = [];
          return obj;
        }, {});
      }

      request({ type: 'websites', status: true });
    });

    return {
      relatedSites,
      allSites,
      isLoading,

    };
  },
});
</script>
<style lang="scss" scoped>
.purpose {
  &__text {
    @include font-normal();
  }
}

.budget {
  margin-top: 110px;
}

.execute {
  margin-top: 60px;
}
</style>
